export var EAppBarStaffVariant = /*#__PURE__*/function (EAppBarStaffVariant) {
  EAppBarStaffVariant["Default"] = "default";
  EAppBarStaffVariant["Backoffice"] = "backoffice";
  EAppBarStaffVariant["Clinic"] = "clinic";
  return EAppBarStaffVariant;
}({});